import { useCallback, useMemo } from 'react';
import { CONVERSATION_TO_TICKET } from 'customer-data-objects/associations/AssociationTypes';
import { getVid } from 'conversations-inbox-lib/contacts/public/operators';
import { getSidebarCardsProps } from '../render-helpers/getSidebarCardsProps';
import { trackEvent } from '../../usage-tracking/clients/usageTracker';
import { getEditPropertySettingsLinkClicked } from '../constants/Events';
import { useAssociatedTickets, useHasTicketCreateAccess } from 'svh-tickets-lib/tickets/public/hooks';
import { reportError } from 'conversations-error-reporting/error-reporting/reportError';
/**
 * Creates the `cardProps` for the customer-data-sidebar to render
 */
export const useSidebarCardProps = ({
  contact,
  conversationId,
  openCreateTicketModal,
  subjectId,
  threadId
} = {}) => {
  const CONVERSATION_TO_TICKET_V2 = `${CONVERSATION_TO_TICKET}_V2`;
  const {
    associatedTicket,
    refetchTickets
  } = useAssociatedTickets({
    conversationId
  });
  const onTicketDisassociationSuccess = useCallback(disassociationPayload => {
    if (disassociationPayload.associationType === CONVERSATION_TO_TICKET || disassociationPayload.associationType === CONVERSATION_TO_TICKET_V2) {
      refetchTickets().catch(error => {
        reportError({
          error
        });
      });
    }
  }, [CONVERSATION_TO_TICKET_V2, refetchTickets]);
  const {
    hasTicketCreateAccess
  } = useHasTicketCreateAccess();
  const handleEditPropertySettingsClicked = useCallback(objectType => {
    trackEvent(getEditPropertySettingsLinkClicked({
      objectType
    }));
  }, []);
  const cardProps = useMemo(() => getSidebarCardsProps({
    associatedTicket,
    conversationId,
    handleEditPropertySettingsClicked,
    hasTicketCreateAccess,
    onTicketDisassociationSuccess,
    openCreateTicketModal,
    subjectId,
    threadId,
    vid: getVid(contact)
  }), [associatedTicket, contact, conversationId, handleEditPropertySettingsClicked, hasTicketCreateAccess, onTicketDisassociationSuccess, openCreateTicketModal, subjectId, threadId]);
  return cardProps;
};